import edjsHTML from "editorjs-html"

export const EditorRenderer = () => ({
  init() {
    const checklistTransform = (block) => {
      const items = block.data.items
        .map((item) => {
          const isChecked = item.meta?.checked || item.checked || false
          const text = item.content || item.text || ""

          const checkbox = isChecked
            ? '<span class="text-green-500 font-bold">✓</span>'
            : '<span class="text-gray-400">☐</span>'

          return `<li class="flex items-center gap-2 mb-2">
          <span class="text-lg leading-none">${checkbox}</span>
          <span class="flex-1">${text}</span>
        </li>`
        })
        .join("")

      return `<ul class="checklist-items list-none pl-0 space-y-2">${items}</ul>`
    }

    const listTransform = (block) => {
      if (block.data.style === "checklist") {
        return checklistTransform(block)
      }

      // 遞迴函式：處理列表項目及其子項目
      const renderListItem = (item) => {
        // 取得項目的文字內容
        const text = item.content || item.text || item

        // 如果有子項目，遞迴渲染
        if (item.items && item.items.length > 0) {
          const nestedItems = item.items
            .map(nestedItem => renderListItem(nestedItem))
            .join("")

          const nestedTag = block.data.style === "ordered" ? "ol" : "ul"
          return `<li>${text}<${nestedTag} class="ml-4 mt-2 space-y-1">${nestedItems}</${nestedTag}></li>`
        }

        // 沒有子項目，直接返回
        return `<li>${text}</li>`
      }

      const items = block.data.items
        .map(item => renderListItem(item))
        .join("")

      const tag = block.data.style === "ordered" ? "ol" : "ul"
      return `<${tag} class="list-disc pl-5 space-y-2">${items}</${tag}>`
    }

    // Spacer 工具轉換
    const spacerTransform = (block) => {
      return '<div style="height: 24px;">&nbsp;</div>'
    }

    // Color 工具轉換
    const colorTransform = (block) => {
      const text = block.data.text || ""
      return `<p>${text}</p>`
    }

    // Embed 工具轉換
    const embedTransform = (block) => {
      const { service, source, embed, width, height, caption } = block.data

      // 為嵌入的內容建立響應式容器
      const aspectRatio = height && width ? `${(height / width) * 100}%` : '56.25%' // 16:9 預設

      const embedHtml = `
        <div class="embed-container relative w-full" style="padding-bottom: ${aspectRatio};">
          <iframe
            class="absolute top-0 left-0 w-full h-full rounded-lg"
            src="${embed}"
            frameborder="0"
            allowfullscreen
            loading="lazy">
          </iframe>
        </div>
      `

      // 如果有說明文字，加入說明
      const captionHtml = caption ? `<p class="text-sm text-gray-600 mt-2 text-center">${caption}</p>` : ''

      return `
        <div class="embed-block my-4">
          ${embedHtml}
          ${captionHtml}
        </div>
      `
    }
    // Gallery 工具轉換
    const galleryTransform = (block) => {
      if (!block.data.images || block.data.images.length === 0) {
        return ''
      }

      // 所有圖片在同一水平線上，等比例分配寬度
      const imageCount = block.data.images.length
      const images = block.data.images
        .map(img => `<div class="relative overflow-hidden"><img src="${img.url}" alt="${img.caption || ''}" class="w-full h-auto block"/></div>`)
        .join('')

      return `<div style="display: grid; grid-template-columns: repeat(${imageCount}, 1fr); gap: 1rem; margin: 1rem 0;">${images}</div>`
    }

    const edjsParser = edjsHTML({
      checklist: checklistTransform,
      list: listTransform,
      spacer: spacerTransform,
      Color: colorTransform,
      embed: embedTransform,
      gallery: galleryTransform,
    })

    try {
      const content = this.$el.textContent.trim()
      if (!content) {
        return
      }

      // 嘗試解析 JSON
      let parsedContent
      try {
        parsedContent = JSON.parse(content)
      } catch (jsonError) {
        // 如果不是有效的 JSON，當作純文字處理
        this.$el.className = "prose md:prose-lg max-w-none flex flex-col"
        this.$el.innerHTML = `<p>${content}</p>`
        return
      }

      // 如果是有效的 Editor.js JSON，進行解析
      const html = edjsParser.parse(parsedContent)
      this.$el.className = "prose md:prose-lg max-w-none flex flex-col [&>ul]:my-0 [&>ol]:my-0"
      this.$el.innerHTML = html
    } catch (error) {
      console.error('EditorRenderer error:', error)
      // 如果發生任何錯誤，保持原始內容
      this.$el.className = "prose md:prose-lg max-w-none flex flex-col"
    }
  },
})
